import { IconDeviceFloppy } from '@tabler/icons-react';
import { AxiosError } from 'axios';
import { FormNavButtons, VatRateElementsGroup } from 'components/molecules';
import { AppForm, AppFormProps } from 'components/organisms';
import { commonTexts, settingsTexts } from 'consts/text';
import { SettlementVatRatesFormFields } from 'types';
import { formFields } from 'consts/form/formFields';

export type SettlementVatRatesEditFormProps = Omit<
    AppFormProps<SettlementVatRatesFormFields>,
    'width' | 'title' | 'name' | 'onFinish' | 'error' | 'withGoBack'
> & {
    axiosError?: AxiosError | null;
    isLoading?: boolean;
    isViewMode?: boolean;
    onFinish: (settlementsStayData: SettlementVatRatesFormFields) => void;
};

export const SettlementVatRatesEditForm = ({
    form,
    axiosError,
    initialValues,
    isViewMode,
    ...props
}: SettlementVatRatesEditFormProps) => {
    const settlementVatRatesEditError = axiosError ? commonTexts.errorMessages.unknown : '';

    return (
        <AppForm<SettlementVatRatesFormFields>
            maxWidth={500}
            form={form}
            name="vatRatesEdit"
            title={settingsTexts.settlements.vatRates.title}
            error={settlementVatRatesEditError}
            {...props}
        >
            <VatRateElementsGroup
                rateTypeFormItemProps={{
                    name: formFields.stayVatRateType,
                    label: settingsTexts.settlements.vatRates.formLabels.vatRate.forStay,
                }}
                releaseReasonFormItemProps={{
                    name: formFields.stayVatReleaseReason,
                    label: settingsTexts.settlements.vatRates.formLabels.vatReleaseReason.forStay,
                }}
                customReleaseReasonFormItemProps={{
                    name: formFields.stayCustomVatReleaseReason,
                    label: settingsTexts.settlements.vatRates.formLabels.customVatReleaseReason
                        .forStay,
                }}
                disabled={isViewMode}
            />
            <VatRateElementsGroup
                rateTypeFormItemProps={{
                    name: formFields.mealVatRateType,
                    label: settingsTexts.settlements.vatRates.formLabels.vatRate.forMeal,
                }}
                releaseReasonFormItemProps={{
                    name: formFields.mealVatReleaseReason,
                    label: settingsTexts.settlements.vatRates.formLabels.vatReleaseReason.forMeal,
                }}
                customReleaseReasonFormItemProps={{
                    name: formFields.mealCustomVatReleaseReason,
                    label: settingsTexts.settlements.vatRates.formLabels.customVatReleaseReason
                        .forMeal,
                }}
                disabled={isViewMode}
            />
            <VatRateElementsGroup
                rateTypeFormItemProps={{
                    name: formFields.starterKitVatRateType,
                    label: settingsTexts.settlements.vatRates.formLabels.vatRate.forStarterKit,
                }}
                releaseReasonFormItemProps={{
                    name: formFields.starterKitVatReleaseReason,
                    label: settingsTexts.settlements.vatRates.formLabels.vatReleaseReason
                        .forStarterKit,
                }}
                customReleaseReasonFormItemProps={{
                    name: formFields.starterKitCustomVatReleaseReason,
                    label: settingsTexts.settlements.vatRates.formLabels.customVatReleaseReason
                        .forStarterKit,
                }}
                disabled={isViewMode}
            />
            {!isViewMode && (
                <FormNavButtons
                    formValuesBeforeChanges={initialValues}
                    buttonText={commonTexts.actionLabels.save}
                    leftIcon={<IconDeviceFloppy size={20} />}
                />
            )}
        </AppForm>
    );
};
